import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute p-x2 bottom-0 text-current-color text-right w-full"
}
const _hoisted_2 = { key: 0 }

import { TileContentModel } from '@/types/B2BcontentServerContract';
import CMSLinkHandler from '../../helpers/CMSLinkHandler.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollageTileDefaultLayoutTextAndLink',
  props: {
    data: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (__props.data.title || (__props.data.link && __props.data.link.text))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.data.title)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.data.title), 1))
          : _createCommentVNode("", true),
        (__props.data.link && __props.data.link.text)
          ? (_openBlock(), _createBlock(CMSLinkHandler, {
              key: 1,
              "link-block": __props.data.link,
              "show-arrow-icon": true,
              "underline-on-hover": true,
              class: "mt-5"
            }, null, 8, ["link-block"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})